module.exports = __webpack_public_path__ + "img/product-6.a57383a5.png";